import { render, staticRenderFns } from "./CertClassic.vue?vue&type=template&id=503830b0&scoped=true"
import script from "./CertClassic.vue?vue&type=script&lang=js"
export * from "./CertClassic.vue?vue&type=script&lang=js"
import style0 from "./CertClassic.vue?vue&type=style&index=0&id=503830b0&prod&scoped=true&lang=css"
import style1 from "./CertClassic.vue?vue&type=style&index=1&id=503830b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503830b0",
  null
  
)

export default component.exports